import { IDateFilter } from "../Interfaces/IKafkaEvents";
import { fetchFromApi, getBackendApiURL } from "../../../BackendFacade";

/**
 * Gets the kafka event logs with pagination
 * @param projectId
 * @param projectKafkaTopic
 * @param linkedId
 * @param dateFilter
 * @param maxAmount
 * @param logLevelFilter
 * @param continuationToken
 */
export function getEventLogs(
    projectId: string,
    projectKafkaTopic: string,
    linkedId: string,
    dateFilter: IDateFilter,
    maxAmount: number,
    logLevelFilter: string,
    continuationToken: string
) {
    let url = getBackendApiURL() + "logs/" + projectId;
    return fetchFromApi(url, "POST", {
        projectKafkaTopic: projectKafkaTopic,
        clientProjectNameFilter: linkedId,
        dateFilter: dateFilter,
        maxAmount: maxAmount,
        logLevelFilter: logLevelFilter,
        continuationToken: continuationToken,
        // sortBy: "Time",
        // currentPage: 1,
        // sortDirection: "desc",
        useNew: "true"
    });
}

/**
 * Gets the log counts
 * @param projectId
 * @param dateFrom
 * @param dateTo
 */
export function getLogCounts(projectId: string, dateFrom: string, dateTo: string) {
    const url = getBackendApiURL() + "logs/" + projectId + "/counts?dateFrom=" + dateFrom + "&dateTo=" + dateTo;
    return fetchFromApi(url, "GET");
}
